import { useEffect, useState } from "react";
import { msUntil } from "../lib/utils";

// Ticks every second; `offsetMs` corrects for client clock drift vs server.
export function useCountdown(deadlineIso, offsetMs = 0) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!deadlineIso) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [deadlineIso]);
  return msUntil(deadlineIso, now + offsetMs);
}
